import moment from 'moment'

export default {
  state: {
    episodes: [],
    total: 0,
    search: '',
    page: 1,
    isLoading: false,
  },

  getters: {
    episodeById: (state) => (id) => {
      if (state.episodes.length === 0) return null
      return state.episodes.find(p => p.id === id)
    },

    episodes: (state) => {
      return state.episodes
    },

    episodesTotal: (state) => {
      return state.total
    },

    episodesSearched: (state) => {
      return state.search
    },

    episodesPaged: (state) => {
      return state.page
    }
  },

  actions: {
    getEpisodes({ commit, dispatch }, { $api, search = '', limit = 10, page = 1 }) {
      commit('setLoading', true)
      $api.get(`episodes/?q=${search}&limit=${limit}&page=${page}`)
        .then((response) => {
          commit('setEpisodes', response.data)
          commit('setLoading', false)
        })
        .catch((error) => {
          dispatch('throwError', error)
          commit('setLoading', false)
        })
    },

  },

  mutations: {
    setEpisodes(state, data) {
      data.episodes.map((e) => {
        e.edit = true
        e.sec = moment(e.date_updated).calendar()
      })
      state.episodes = data.episodes
      state.total = data.total
      state.page = data.page
      state.search = data.q
    },
    setLoading(state, data) {
      state.isLoading = data
    }

  }
}
